import { styled, Typography } from '@mui/material';

export const ListW = styled('div')`
  display: flex;
  justify-content: space-between;
  padding: 0px 16px;
  margin-top: 24px;

  @media (max-width: 1023px) {
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    margin-top: 0px;
  }
`;

export const PostCardsGrid = styled('div')`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.white.main};
  padding: 16px;
  gap: 8px;
  margin-top: 40px;

  @media (max-width: 1023px) {
    margin-top: 0px;
    grid-template-columns: 1fr;
  }
`;

export const PostCardWrapper = styled('div')`
  overflow: hidden;

  /* Force PostW (Container > PostW) to fill the column width */
  & > div > div {
    min-width: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    margin-bottom: 0 !important;
    box-sizing: border-box;
  }
`;

export const SeeAllLink = styled(Typography)`
  position: absolute;
  right: 8px;
  bottom: 8px;
  font-size: 14px;
  text-align: right;
  margin-top: 12px;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: 1023px) {
    position: relative;
  }
`;
